import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { Guide } from "../HelpCenterTypes";

type GuideListMenuProps = {
  list: Guide[];
  className?: string;
  categorySlug?: string;
  maxItems?: number;
};

/**
 * The guide list menu component.
 */
function GuideListMenu(props: GuideListMenuProps) {
  const { list = [], className, categorySlug = "", maxItems = 999 } = props;

  if (list?.length === 0) {
    return null;
  }

  return (
    <div className={clsx("w-full", className)}>
      {list.slice(0, maxItems).map((item) => (
        <Typography
          component={Link}
          className="flex mt-12 font-medium no-underline hover:underline"
          key={item.id}
          to={categorySlug !== "" ? `${categorySlug}/${item.slug}` : item.slug}
          color="secondary"
          role="button"
        >
          {item.title}
        </Typography>
      ))}
    </div>
  );
}

export default GuideListMenu;
